import { editedUpdate } from "helpers/reduxUtils";
import {
  SMSOUT_LOADING,
  SMSOUT_LOADED,
  SUBCHARGES_GROUPED_LOADED,
  SMSOUT_GROUPED_LOADED,
  SUBCHARGES_LOADING,
  SUBCHARGES_FAILED,
  SUBCHARGES_LOADED,
  REPORT_SUBCHARGE,
  REPORT_LOADING,
  SMSOUT_FAILED,
  REPORT_SMSOUT,
  REPORT_SMSIN,
  REPORT_IVROUT,
  REPORT_IVRIN,
  REPORT_FAILED,
  STATUS_LOADING,
  STATUS_SMSOUT_LOADED,
  STATUS_SMSIN_LOADED,
  STATUS_IVROUT_LOADED,
  STATUS_IVRIN_LOADED,
  STATUS_FAILED,
  USSD_REPORT_LOADING,
  USSD_REPORT_LOADED,
  USSD_REPORT_FAILED,
  USSD_GREPORT_LOADED,
  SMSOUT_NETWORK_TRANS_LOADED,
  SMSOUT_ALL_NETWORK_TRANS_LOADED,
  SMSOUT_NETWORK_SP_TRANS,
  VAS_LOADING,
  TWREQUESTS_LOADED,
  SUBREQUEST_LOADED,
  WHLOGS_LOADED,
  TWREQUESTS_GROUP_LOADED,
  SUBREQUEST_GROUP_LOADED,
  WHLOGS_GROUP_LOADED,
  USSD_GROUPED_LOADED,
  SMSIN_DETAILS_LOADED,
  USSD_FAILED,
  VAS_FAILED,
  SUBREQUEST_EXPORT,
  SMSOUT_DETAILS_LOADED,
  SMSOUT_NETWORK_SP_TRANS_EXPORTED,
  USSD_CODEPHONE_REPORT_LOADED,
  USSD_CODESESSION_REPORT_LOADED,
  LOGOUT,
  SMSOUT_SUCCESS,
  REPORT_SMS_SENDERID,
  SMSOUT_SUBMITED_LOADED,
  SUB_HISTORY_LOAD,
  WHLOGS_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  smsouts: [],
  subscharges: [],
  smsoutsGrouped: null,
  subChargesGrouped: [],
  reportSubcharges: [],
  reportSmsout: [],
  reportSmsin: [],
  smsinDetails: [],
  reportIvrout: [],
  reportIvrin: [],
  reportUssd: [],
  allSmpp: [],
  twrequests: [],
  subrequests: [],
  whlogs: [],
  ussdServiceSession: [],
  ussdMsisdnSession: [],
  twrequestsGrouped: [],
  subrequestsGrouped: [],
  whlogsGrouped: [],
  networkTransactions: [],
  spNetworktrans: [],
  senderIdReporting: [],
  subHist: [],
  statusIvrin: null,
  statusIvrout: null,
  statusSmsin: null,
  statusSmsout: null,
  ussdGrouped: null,
  ussdStats: null,
  smspushdetails: null,
  submitedReport: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SUBCHARGES_LOADING:
    case USSD_REPORT_LOADING:
    case SMSOUT_LOADING:
    case REPORT_LOADING:
    case STATUS_LOADING:
    case VAS_LOADING:
      return {
        ...state,
        loading: true,
        smspushdetails: null,
      };

    case SMSOUT_SUBMITED_LOADED:
      return {
        ...state,
        loading: false,
        submitedReport: action.payload,
      };

    case REPORT_SMS_SENDERID:
      return {
        ...state,
        loading: false,
        senderIdReporting: action.payload,
      };

    case SUBREQUEST_EXPORT:
      return {
        ...state,
        loading: false,
      };

    case SMSOUT_DETAILS_LOADED:
      return {
        ...state,
        loading: false,
        smspushdetails: action.payload,
      };

    case USSD_CODESESSION_REPORT_LOADED:
      return {
        ...state,
        loading: false,
        ussdServiceSession: action.payload,
      };

    case USSD_CODEPHONE_REPORT_LOADED:
      return {
        ...state,
        loading: false,
        ussdMsisdnSession: action.payload,
      };

    case SMSIN_DETAILS_LOADED:
      return {
        ...state,
        loading: false,
        smsinDetails: action.payload,
      };

    case SMSOUT_NETWORK_SP_TRANS:
      return {
        ...state,
        loading: false,
        spNetworktrans: action.payload,
      };

    case WHLOGS_GROUP_LOADED:
      return {
        ...state,
        loading: false,
        whlogsGrouped: action.payload,
      };

    case USSD_GROUPED_LOADED:
      return {
        ...state,
        loading: false,
        ussdStats: action.payload,
      };

    case SUB_HISTORY_LOAD:
      return {
        ...state,
        loading: false,
        subHist: action.payload,
      };
    case SUBREQUEST_GROUP_LOADED:
      return {
        ...state,
        loading: false,
        subrequestsGrouped: action.payload,
      };
    case TWREQUESTS_GROUP_LOADED:
      return {
        ...state,
        loading: false,
        twrequestsGrouped: action.payload,
      };
    case SUBREQUEST_LOADED:
      return {
        ...state,
        loading: false,
        subrequests: action.payload,
      };
    case TWREQUESTS_LOADED:
      return {
        ...state,
        loading: false,
        twrequests: action.payload,
      };
    case WHLOGS_LOADED:
      return {
        ...state,
        loading: false,
        whlogs: action.payload,
      };
    case SMSOUT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SMSOUT_ALL_NETWORK_TRANS_LOADED:
      return {
        ...state,
        loading: false,
        allSmpp: action.payload,
      };
    case SMSOUT_NETWORK_TRANS_LOADED:
      return {
        ...state,
        loading: false,
        networkTransactions: action.payload,
      };
    case USSD_GREPORT_LOADED:
      return {
        ...state,
        loading: false,
        ussdGrouped: action.payload,
      };
    case USSD_REPORT_LOADED:
      return {
        ...state,
        reportUssd: action.payload,
        loading: false,
      };
    case REPORT_SUBCHARGE:
      return {
        ...state,
        loading: false,
        reportSubcharges: action.payload,
      };
    case REPORT_SMSIN:
      return {
        ...state,
        loading: false,
        reportSmsin: action.payload,
      };
    case REPORT_SMSOUT:
      return {
        ...state,
        loading: false,
        reportSmsout: action.payload,
      };
    case REPORT_IVROUT:
      return {
        ...state,
        loading: false,
        reportIvrout: action.payload,
      };
    case REPORT_IVRIN:
      return {
        ...state,
        loading: false,
        reportIvrin: action.payload,
      };
    case SMSOUT_GROUPED_LOADED:
      return {
        ...state,
        loading: false,
        smsoutsGrouped: action.payload,
      };
    case SMSOUT_LOADED:
      return {
        ...state,
        loading: false,
        smsouts: action.payload,
      };
    case SUBCHARGES_LOADED:
      return {
        ...state,
        loading: false,
        subscharges: action.payload,
      };
    case SUBCHARGES_GROUPED_LOADED:
      return {
        ...state,
        loading: false,
        subChargesGrouped: action.payload,
      };
    case STATUS_SMSOUT_LOADED:
      return {
        ...state,
        loading: false,
        statusSmsout: action.payload,
      };
    case STATUS_SMSIN_LOADED:
      return {
        ...state,
        loading: false,
        statusSmsin: action.payload,
      };
    case STATUS_IVROUT_LOADED:
      return {
        ...state,
        loading: false,
        statusIvrout: action.payload,
      };
    case STATUS_IVRIN_LOADED:
      return {
        ...state,
        loading: false,
        statusIvrin: action.payload,
      };
    case WHLOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        whlogs: editedUpdate(state.whlogs, action.payload),
      };
    case VAS_FAILED:
    case USSD_FAILED:
    case STATUS_FAILED:
    case SMSOUT_FAILED:
    case REPORT_FAILED:
    case SUBCHARGES_FAILED:
    case USSD_REPORT_FAILED:
    case SMSOUT_NETWORK_SP_TRANS_EXPORTED:
      return {
        ...state,
        loading: false,
        smspushdetails: null,
      };

    case LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
